import { useEffect } from 'react';

export const useStructuredData = (structuredData) => {
  useEffect(() => {
    // Remove existing structured data script for this page
    const existingScript = document.querySelector('script[data-page-schema]');
    if (existingScript) {
      document.head.removeChild(existingScript);
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-page-schema', 'true');
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      const scriptToRemove = document.querySelector('script[data-page-schema]');
      if (scriptToRemove) {
        document.head.removeChild(scriptToRemove);
      }
    };
  }, [structuredData]);
};
